import React from 'react'
import AppAccess from "../../components/AppAccess";
import { Home } from "./Home";

export const AppAccessPage = () => <Home><AppAccess /></Home>